// extracted by mini-css-extract-plugin
module.exports = {"label":"textarea_label__Fl9CE font-bold inline-block mr-2","content":"textarea_content__xEJt0 inline-block","contentHtml":"textarea_contentHtml__JiHj9 block"};